import { render, staticRenderFns } from "./StatsCaughtUp.vue?vue&type=template&id=f13e58be&scoped=true&lang=html&"
import script from "./StatsCaughtUp.vue?vue&type=script&lang=js&"
export * from "./StatsCaughtUp.vue?vue&type=script&lang=js&"
import style0 from "./StatsCaughtUp.vue?vue&type=style&index=0&id=f13e58be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13e58be",
  null
  
)

export default component.exports